import moment from 'moment';

const formatDate = 'MMM D, YYYY';
const WEEK = 7;

class DateServices {
    // eslint-disable-next-line class-methods-use-this
    getCurrentTimeUTC() {
        const d = new Date();
        return new Date((d.getTime() + (d.getTimezoneOffset() * 60000)));
    }

    // eslint-disable-next-line class-methods-use-this
    daysInMonth(month, year) {
        return 32 - new Date(year, month, 32).getDate();
    }

    // eslint-disable-next-line consistent-return
    getDateRangeString(dateRange) {
        if (dateRange.fromStart && dateRange.toEnd) {
            return `${moment(dateRange.fromStart)
                .format(formatDate)
            } - ${moment(dateRange.toEnd)
                .format(formatDate)}`;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    getFirstDayOfWeek(date) {
        const dateCopy = new Date(date);
        const dayInWeek = dateCopy.getDay(); // sunday is 0
        const dayInMonth = dateCopy.getDate(); // 1-31
        const firstDayOfWeek = dayInMonth - dayInWeek;
        dateCopy.setDate(firstDayOfWeek);
        return dateCopy;
    }

    getLastDayOfWeek(date) {
        let dateCopy = new Date(date);
        const dayInWeek = dateCopy.getDay(); // sunday is 0
        const dayInMonth = dateCopy.getDate(); // 1-31
        const lastDayOfWeek = dayInMonth + (6 - dayInWeek);
        dateCopy.setDate(lastDayOfWeek);
        const today = this.getCurrentTimeUTC();
        if (dateCopy > today) {
            dateCopy = today;
        }
        return dateCopy;
    }

    getLastDayOfMonth(date) {
        const today = this.getCurrentTimeUTC();
        let end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        if (end > today) {
            end = today;
        }
        return end;
    }

    // eslint-disable-next-line class-methods-use-this
    getPresetsFunctions(shouldIncludeToday = true) {
        const includeToday = shouldIncludeToday;
        const that = this;
        return {
            today: {
                dates() {
                    const dates = {};
                    (dates.from = that.getCurrentTimeUTC()).setHours(0, 0, 0, 0);
                    (dates.to = new Date(dates.from)).setHours(23, 59, 59, 0);
                    return dates;
                }
            },
            yesterday: {
                dates() {
                    const dates = {};
                    dates.from = new Date(((that.getCurrentTimeUTC())) - 24 * 3600 * 1000);
                    (dates.to = new Date(dates.from)).setHours(23, 59, 59, 0);
                    return dates;
                }
            },
            last7days: {
                dates() {
                    const dates = {};
                    let toDelta = 0;
                    let fromDelta = 6 * 24 * 3600 * 1000;
                    if (!includeToday) {
                        toDelta = 24 * 3600 * 1000;
                        fromDelta = 7 * 24 * 3600 * 1000;
                    }
                    dates.from = new Date(
                        (that.getCurrentTimeUTC()) - fromDelta
                    );
                    dates.to = new Date(
                        (that.getCurrentTimeUTC().setHours(
                            23, 59, 59, 0)
                        ) - toDelta
                    );
                    return dates;
                }
            },
            last14days: {
                dates() {
                    const dates = {};
                    let toDelta = 0;
                    let fromDelta = 13 * 24 * 3600 * 1000;
                    if (!includeToday) {
                        toDelta = 24 * 3600 * 1000;
                        fromDelta = 14 * 24 * 3600 * 1000;
                    }
                    dates.from = new Date(
                        (that.getCurrentTimeUTC()) - fromDelta
                    );
                    dates.to = new Date(
                        (that.getCurrentTimeUTC().setHours(
                            23, 59, 59, 0
                        )) - toDelta
                    );
                    return dates;
                }
            },
            last30days: {
                dates() {
                    const dates = {};
                    let toDelta = 0;
                    let fromDelta = 29 * 24 * 3600 * 1000;
                    if (!includeToday) {
                        toDelta = 24 * 3600 * 1000;
                        fromDelta = 30 * 24 * 3600 * 1000;
                    }
                    dates.from = new Date(
                        (that.getCurrentTimeUTC()) - fromDelta
                    );
                    dates.to = new Date(
                        (that.getCurrentTimeUTC().setHours(
                            23, 59, 59, 0
                        )) - toDelta
                    );
                    return dates;
                }
            },
            last31days: {
                dates() {
                    const dates = {};
                    let toDelta = 0;
                    let fromDelta = 30 * 24 * 3600 * 1000;
                    if (!includeToday) {
                        toDelta = 24 * 3600 * 1000;
                        fromDelta = 31 * 24 * 3600 * 1000;
                    }
                    dates.from = new Date(
                        (that.getCurrentTimeUTC()) - fromDelta
                    );
                    dates.to = new Date(
                        (that.getCurrentTimeUTC().setHours(
                            23, 59, 59, 0
                        )) - toDelta
                    );
                    return dates;
                }
            },
            last60days: {
                dates() {
                    const dates = {};
                    let toDelta = 0;
                    let fromDelta = 59 * 24 * 3600 * 1000;
                    if (!includeToday) {
                        toDelta = 24 * 3600 * 1000;
                        fromDelta = 60 * 24 * 3600 * 1000;
                    }
                    dates.from = new Date(
                        (that.getCurrentTimeUTC()) - fromDelta
                    );
                    dates.to = new Date(
                        (that.getCurrentTimeUTC().setHours(
                            23, 59, 59, 0
                        )) - toDelta
                    );
                    return dates;
                }
            },
            last90days: {
                dates() {
                    const dates = {};
                    let toDelta = 0;
                    let fromDelta = 89 * 24 * 3600 * 1000;
                    if (!includeToday) {
                        toDelta = 24 * 3600 * 1000;
                        fromDelta = 90 * 24 * 3600 * 1000;
                    }
                    dates.from = new Date(
                        (that.getCurrentTimeUTC()) - fromDelta
                    );
                    dates.to = new Date(
                        (that.getCurrentTimeUTC().setHours(
                            23, 59, 59, 0
                        )) - toDelta
                    );
                    return dates;
                }
            },
            thisMonth: {
                dates() {
                    const dates = {};
                    const date = new Date();
                    const firstDay = new Date(
                        date.getFullYear(), date.getMonth(), 1
                    );
                    if (!includeToday) {
                        const yesterday = new Date(
                            ((that.getCurrentTimeUTC()).setHours(
                                0, 0, 0, 0
                            )) - 24 * 3600 * 1000
                        );
                        if (yesterday < firstDay) {
                            dates.to = firstDay;
                        } else {
                            dates.to = yesterday;
                        }
                    } else {
                        (dates.to = that.getCurrentTimeUTC()).setHours(
                            0, 0, 0, 0
                        );
                    }
                    dates.from = firstDay;
                    return dates;
                }
            },
            lastMonth: {
                dates() {
                    const dates = {};
                    const date = new Date();
                    dates.from = new Date(
                        date.getFullYear(), date.getMonth() - 1, 1
                    );
                    dates.to = new Date(
                        date.getFullYear(), date.getMonth(), 0
                    );
                    return dates;
                }
            },
            last4weeks: {
                dates() {
                    const dates = {};
                    const today = that.getCurrentTimeUTC();
                    const firstDayOfWeek = that.getFirstDayOfWeek(today);
                    // go back 3 weeks, the current week is the last
                    dates.from = new Date(
                        firstDayOfWeek.setDate(firstDayOfWeek.getDate() - (WEEK * 3))
                    );
                    dates.to = new Date(
                        (today.setHours(23, 59, 59, 0))
                    );
                    return dates;
                }
            },
            last12weeks: {
                dates() {
                    const dates = {};
                    const today = that.getCurrentTimeUTC();
                    const firstDayOfWeek = that.getFirstDayOfWeek(today);
                    // go back 11 weeks, the current week is the last
                    dates.from = new Date(
                        firstDayOfWeek.setDate(firstDayOfWeek.getDate() - (WEEK * 11))
                    );
                    dates.to = new Date(
                        (today.setHours(23, 59, 59, 0))
                    );
                    return dates;
                }
            },
            last26weeks: {
                dates() {
                    const dates = {};
                    const today = that.getCurrentTimeUTC();
                    const firstDayOfWeek = that.getFirstDayOfWeek(today);
                    // go back 23 weeks, the current week is the last
                    dates.from = new Date(
                        firstDayOfWeek.setDate(firstDayOfWeek.getDate() - (WEEK * 25))
                    );
                    dates.to = new Date(
                        (today.setHours(23, 59, 59, 0))
                    );
                    return dates;
                }
            },
            last52weeks: {
                dates() {
                    const dates = {};
                    const today = that.getCurrentTimeUTC();
                    const firstDayOfWeek = that.getFirstDayOfWeek(today);
                    // go back 51 weeks, the current week is the last
                    dates.from = new Date(
                        firstDayOfWeek.setDate(firstDayOfWeek.getDate() - (WEEK * 51))
                    );
                    dates.to = new Date(
                        (today.setHours(23, 59, 59, 0))
                    );
                    return dates;
                }
            },
            last3months: {
                dates() {
                    const dates = {};
                    const date = that.getCurrentTimeUTC();
                    const firstDay = new Date(
                        date.getFullYear(), date.getMonth() - 2, 1
                    );
                    (dates.to = that.getCurrentTimeUTC()).setHours(
                        0, 0, 0, 0
                    );
                    dates.from = firstDay;
                    return dates;
                }
            },
            last6months: {
                dates() {
                    const dates = {};
                    const date = that.getCurrentTimeUTC();
                    const firstDay = new Date(
                        date.getFullYear(), date.getMonth() - 5, 1
                    );
                    (dates.to = that.getCurrentTimeUTC()).setHours(
                        0, 0, 0, 0
                    );
                    dates.from = firstDay;
                    return dates;
                }
            },
            last12months: {
                dates() {
                    const dates = {};
                    const date = that.getCurrentTimeUTC();
                    const firstDay = new Date(
                        date.getFullYear(), date.getMonth() - 11, 1
                    );
                    (dates.to = that.getCurrentTimeUTC()).setHours(
                        0, 0, 0, 0
                    );
                    dates.from = firstDay;
                    return dates;
                }
            },
            last24months: {
                dates() {
                    const dates = {};
                    const date = that.getCurrentTimeUTC();
                    const firstDay = new Date(
                        date.getFullYear(), date.getMonth() - 23, 1
                    );
                    (dates.to = that.getCurrentTimeUTC()).setHours(
                        0, 0, 0, 0
                    );
                    dates.from = firstDay;
                    return dates;
                }
            },
            last36months: {
                dates() {
                    const dates = {};
                    const date = that.getCurrentTimeUTC();
                    const firstDay = new Date(
                        date.getFullYear(), date.getMonth() - 35, 1
                    );
                    (dates.to = that.getCurrentTimeUTC()).setHours(
                        0, 0, 0, 0
                    );
                    dates.from = firstDay;
                    return dates;
                }
            }
        };
    }

    createMonth(month, year, includeToday = true, setFuture = true) {
        const parsedMonth = {
            weeks: [], days: {}, month, year
        };
        let day;
        let week;
        const firstDay = new Date(year, month, 1);
        const dayInWeek = firstDay.getDay();
        let dayCounter = 1;
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        const maxDay = this.daysInMonth(month, year);
        for (let i = 0; i < 6; i++) {
            week = [];
            for (let j = 0; j < 7; j++) {
                day = { };
                if (i === 0) {
                    if (dayInWeek > 0 && j < dayInWeek) {
                        day.value = 0;
                    }
                }
                if (dayCounter > maxDay) {
                    day.value = 0;
                }

                if (!day.value && day.value !== 0) {
                    day.value = dayCounter;
                    dayCounter += 1;
                    parsedMonth.days[day.value] = day;
                    day.date = new Date(year, month, day.value);
                    if (now < day.date && setFuture) {
                        day.isFuture = true;
                    } else if (day.date.getTime() === now.getTime()) {
                        day.isToday = true;
                        if (!includeToday) {
                            day.disabled = true;
                        }
                    }
                }
                week.push(day);
            }
            parsedMonth.weeks.push(week);
        }

        return parsedMonth;
    }
}

export default new DateServices();
